import { ListItem, ListItemText, TextField } from "@mui/material";
import { type FieldProps } from "formik";
import { Autocomplete, type AutocompleteRenderInputParams } from "formik-mui";
import { useState } from "react";
import type { TestSzenarioVersionSuchErgebnis } from "../api";
import { useTestSzenarioVersionen } from "../pages/test-szenarios/data";
import SuspenseBoundary from "./SuspenseBoundary";

export type Props = {
    disabled?: boolean;
  servoTypId?: string;
  label: string;
  required?: boolean;
} & FieldProps;

export default function TestSzenarioVersionSelect(props: Props) {
  return (
    <SuspenseBoundary>
      <Content {...props} />
    </SuspenseBoundary>
  );
}

function Content({ disabled, field, form, meta, servoTypId, ...props }: Props) {
  const [suche, setSuche] = useState("");
  const versionen = useTestSzenarioVersionen({
    suche,
    servoTypId,
    aktuell: true,
    max: 10,
  }).elemente;

  return (
    <Autocomplete
      field={field}
      form={form}
      meta={meta}
      autoComplete
      filterSelectedOptions
      onInputChange={(_, newInputValue) => setSuche(newInputValue)}
      options={versionen}
      disabled={disabled}
      getOptionLabel={(option: string | TestSzenarioVersionSuchErgebnis) =>
        typeof option === "string" ? option : option.testSzenario.name
      }
      renderOption={(props, option) => (
        <ListItem {...props} disablePadding>
          <ListItemText
            primary={option.testSzenario.name}
            secondary={
              <>
                Version {option.version} vom{" "}
                {new Date(option.erstellt.zeitpunkt).toLocaleDateString()}
              </>
            }
          />
        </ListItem>
      )}
      renderInput={(params: AutocompleteRenderInputParams) => (
        <TextField name={field.name} {...props} {...params} />
      )}
    />
  );
}
